import type { FaireProductEntity } from "../../entity_types/product";

export const p_cc9uc7sfbj: FaireProductEntity = {
  token: "p_cc9uc7sfbj",
  type: "product",
  name: "Celestial Constellations Notebook",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/d1e5da6949d280317c76a7b484a41560a4504c1b716ade06602ad35f9db987b1.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.5,
  description: "This celestial journal offers an elegant space for you to write down your thoughts, jot down your lists, or doodle your dreams. It features dot-grid pages with write-in datelines, and twelve illustrations of zodiac constellations from an extraordinary sky atlas in the collection of the American Museum of Natural History’s rare book library—a journal to gift or treasure.",
  tags: [],
  msrpDollars: 16.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:13.386Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
